import { Api } from '@coderhouse/common'
import { Course, ICourse } from '@/models/course'

const { VUE_APP_HOME_SERVICE, VUE_APP_FLAGS_SERVICE, VUE_APP_CH_API_BFF } = process.env

async function getCourses(): Promise<Course[]> {
  const user = localStorage.getItem('user')
  if (user) {
    const userObj = JSON.parse(user)
    let flagRules
    try {
      const newHomeRules = await Api.post(
        `${VUE_APP_FLAGS_SERVICE}/flags/v1/new-home/evaluate/${userObj.id}`,
        {
          user: {
            id: userObj.id,
            country: userObj.country,
            email: userObj.email
          }
        },
        null,
        {
          headers: {
            'X-Namespace': 'home'
          }
        }
      )
      flagRules = newHomeRules.rules
    } catch (error) {
      flagRules = []
    }

    let courses = []
    if (flagRules.length > 0) {
      courses = await Api.get(`${VUE_APP_HOME_SERVICE}/api/v1/courses`)
    } else {
      courses = await Api.get(`${VUE_APP_CH_API_BFF}/v1/home/courses?showCoderU=true`)
    }

    const items = courses.map((item: ICourse) => new Course(item))
    return items
  }
  return []
}

export { getCourses }
